import { useState } from 'react';

interface LoginCredentials {
  username: string;
  password: string;
}

interface User {
  username: string;
  displayName: string;
  role: 'Executive' | 'Project Manager' | 'Client';
}

// Mock user for demo purposes
const MOCK_CREDENTIALS = {
  admin: { username: 'admin', password: 'admin' },
  client: { username: 'client', password: 'client' }
};

const MOCK_USERS: User[] = [
  {
    username: 'admin',
    displayName: 'Administrator',
    role: 'Executive'
  },
  {
    username: 'pm',
    displayName: 'Project Manager',
    role: 'Project Manager'
  },
  {
    username: 'client',
    displayName: 'TechCorp Industries',
    role: 'Client'
  }
];

export function useAuth() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const [selectedRole, setSelectedRole] = useState<'Executive' | 'Project Manager'>('Executive');

  const login = async (credentials: LoginCredentials): Promise<boolean> => {
    if (credentials.username === MOCK_CREDENTIALS.admin.username && 
        credentials.password === MOCK_CREDENTIALS.admin.password) {
      setIsLoggedIn(true);
      setUser({ ...MOCK_USERS[0], role: selectedRole });
      return true;
    }
    if (credentials.username === MOCK_CREDENTIALS.client.username && 
        credentials.password === MOCK_CREDENTIALS.client.password) {
      setIsLoggedIn(true);
      setUser(MOCK_USERS[2]);
      return true;
    }
    return false;
  };

  const switchRole = (role: 'Executive' | 'Project Manager') => {
    setSelectedRole(role);
    if (user) {
      setUser({ ...user, role });
    }
  };
  const logout = () => {
    setIsLoggedIn(false);
    setUser(null);
  };

  return {
    isLoggedIn,
    user,
    login,
    logout,
    switchRole,
    selectedRole
  };
}